import { NgModule ,CUSTOM_ELEMENTS_SCHEMA} from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import { ChartsModule } from "ng2-charts";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { NgxEchartsModule } from "ngx-echarts";
import * as echarts from "echarts";
import { AgmCoreModule } from "@agm/core";
import { LeafletModule } from "@asymmetrik/ngx-leaflet";
import { FullCalendarModule } from "@fullcalendar/angular";
// import { NzDatePickerModule, NzDividerModule, NzTableModule } from 'ng-zorro-antd';
import { DragDropModule } from "@angular/cdk/drag-drop";

import { environment } from "../../environments/environment";
import { UIModule } from "../ui/ui.module";
import { LayoutModule } from "../layout/layout.module";
import { BasePageComponent } from "./base-page";

import { MainAnalyticsPageComponentnt } from "../pages/main-analytics";

import { Page404Component } from "./page-404";
import { AddDishDialog, AddMenuNameDialog, AllergenCartDialog, DishDeleteConfirmDialog, MainPageComponentnt, ReviewedByDialog, UnsutaibleDPChartDialog } from "./main";
import { PageSignInComponent } from "./sign-in";
import { ForgotPasswordComponent } from "../pages/forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "../pages/reset-password/reset-password.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { NgHttpLoaderModule } from "ng-http-loader";
import { RestaurantSettingComponent } from "./restaurant-setting/restaurant-setting.component";
import { RestaurantTablesComponent } from "./restaurant-tables/restaurant-tables.component";
import { DineinordersComponent } from "./dineinorders/dineinorders.component";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatBadgeModule } from "@angular/material/badge";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatStepperModule } from "@angular/material/stepper";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSliderModule } from "@angular/material/slider";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatTreeModule } from "@angular/material/tree";
import { AboutrestoComponent } from "./aboutresto/aboutresto.component";
import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";
import { AddonComponent } from "./addon/addon.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { Ng2SearchPipeModule } from "ng2-search-filter";
import {
  restaurantDeletePopup,
  RestaurantlistsComponent,
  restaurantMasterAddPopup,
} from "./restaurantlists/restaurantlists.component";
import { SuperadmindashboardComponent } from "./superadmindashboard/superadmindashboard.component";
import {
  AllergensdietaryComponent,
  AddAllergens,
  UpdateAllergens,
  Diet,
} from "./allergensdietary/allergensdietary.component";
import {
  CategorycuisineComponent,
  Cuisines,
  AddCategoriesCuisines,
  UpdateCategoriesCuisines,
} from "./categorycuisine/categorycuisine.component";
import { AccountsettingComponent,SuperAccountSettingComponent,UpdateRestoPassword } from "./accountsetting/accountsetting.component";
import { SuperadminsidenavComponent } from "./superadminsidenav/superadminsidenav.component";
import { DeletePopupComponent } from "./delete-popup/delete-popup.component";

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastrModule } from "ngx-toastr";
import { D2AllRestoComponent,ClaimedRestoComponent, PartialClaimRestoComponent } from './d2-all-resto/d2-all-resto.component';
import { ViewRestoComponent } from './view-resto/view-resto.component';
import { ClaimBuisnessComponent,DialogClaimCheckComponent,FinalPopupComponent,RestoClaimDetailsComponent } from './claim-buisness/claim-buisness.component';

import {NgOtpInputModule} from 'ng-otp-input';
import { L2RestoDetailsComponent } from './l2-resto-details/l2-resto-details.component'
import { ScrollService } from "../services/scroll/scroll.service";
import { AllergensDialog, CategoryDialog, IngredientDialog, NutrilabelDashboardComponent, SuccessDialog } from './nutrilabel-dashboard/nutrilabel-dashboard.component';
import { WeeklyTopComponent } from './weekly-top/weekly-top.component';
import { MasterRestaurantComponent } from './master-restaurant/master-restaurant.component';
import { ClaimQrCodeComponent } from './claim-qr-code/claim-qr-code.component';
import { EmailTemplateComponent, EmailTemplateEditorComponent } from './email-template/email-template.component';
import { MenuLayoutComponent } from './menu-layout/menu-layout.component';
import { NgApexchartsModule } from "ng-apexcharts";
import { RegulatoryAndEventPlanComponent } from './regulatory-and-event-plan/regulatory-and-event-plan.component';
// import { NgbAlertModule, NgbDatepickerModule, NgbDateStruct, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
@NgModule({
  imports: [
   
    CommonModule,
    FormsModule,
    MatIconModule,
    NgxMaterialTimepickerModule,
    ReactiveFormsModule,
    RouterModule,
    NgHttpLoaderModule.forRoot(),
    ChartsModule,
    NgxChartsModule,
    NgxEchartsModule.forRoot({
      echarts: { init: echarts.init },
    }),
    AgmCoreModule.forRoot({
      apiKey: environment.googleMapApiKey,
    }),
    LeafletModule,
    FullCalendarModule,
    // NzDatePickerModule,
    // NzDividerModule,
    // NzTableModule,
    DragDropModule,
    NgSelectModule,
    FormsModule,
    UIModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    Ng2SearchPipeModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatFormFieldModule,

    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    LayoutModule,

    NgApexchartsModule,
    BrowserAnimationsModule,
    NgOtpInputModule,
    ToastrModule.forRoot(),
    // NgbAlertModule, NgbDatepickerModule,
  ],
  declarations: [
    BasePageComponent,
    MainPageComponentnt,
    Page404Component,
    PageSignInComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    MainAnalyticsPageComponentnt,
    RestaurantSettingComponent,
    RestaurantTablesComponent,
    DineinordersComponent,
    AboutrestoComponent,
    AddonComponent,
    RestaurantlistsComponent,
    SuperadmindashboardComponent,
    AllergensdietaryComponent,
    CategorycuisineComponent,
    AccountsettingComponent,
    SuperadminsidenavComponent,
    DeletePopupComponent,
    Cuisines,
    AddCategoriesCuisines,
    UpdateCategoriesCuisines,
    AddAllergens,
    UpdateAllergens,
    Diet,
    restaurantDeletePopup,
    SuperAccountSettingComponent,
    UpdateRestoPassword,
    D2AllRestoComponent,
    ViewRestoComponent,
    ClaimBuisnessComponent,
    RestoClaimDetailsComponent,
    ClaimedRestoComponent,
    L2RestoDetailsComponent,
    NutrilabelDashboardComponent,
    IngredientDialog,
    CategoryDialog,
    AllergensDialog,
    SuccessDialog,
    AddDishDialog,
    WeeklyTopComponent,
    AllergenCartDialog,
    ReviewedByDialog,
    PartialClaimRestoComponent,
    AddMenuNameDialog,
    restaurantMasterAddPopup,
    MasterRestaurantComponent,
    ClaimQrCodeComponent,
    FinalPopupComponent,
    DishDeleteConfirmDialog,
    DialogClaimCheckComponent,
    UnsutaibleDPChartDialog,
    EmailTemplateComponent,
    EmailTemplateEditorComponent,
    MenuLayoutComponent,
    RegulatoryAndEventPlanComponent
  ],
  exports: [],
  entryComponents: [
    DeletePopupComponent,
    Cuisines,
    AddCategoriesCuisines,
    UpdateCategoriesCuisines,
    AddAllergens,
    UpdateAllergens,
    restaurantDeletePopup,
    Diet,
    UpdateRestoPassword,
    IngredientDialog,
    CategoryDialog,
    AllergensDialog,
    SuccessDialog,
    AddDishDialog,
    AllergenCartDialog,
    ReviewedByDialog,
    AddMenuNameDialog,
    restaurantMasterAddPopup,
    DishDeleteConfirmDialog,
    DialogClaimCheckComponent,
    UnsutaibleDPChartDialog,
    MenuLayoutComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  providers:[ScrollService]
})
export class PagesModule {}
